export const contest = {
  qjy: 'Aller trader',
  grbm: 'Inscription individuelle',
  qdl: 'Se connecter',
  bsyjs: 'La compétition est terminée',
  bsjs: 'Fin de la compétition',
  djs: 'Compte à rebours avant le concours de trading simulé {v1}',
  days: 'jours',
  hours: 'heures',
  minutes: 'minutes',
  seconds: 'secondes',
  ljyq: 'Inviter maintenant',
  tdbm: 'Inscription en équipe',
  qzc: 'S inscrire',
  qrsfgrbm: 'Confirmer la participation individuelle ?',
  qxbm: 'Annuler l inscription',
  qrbm: 'Confirmer l inscription',
  gxnbmcg: 'Félicitations, inscription réussie ! Vous recevrez 100 000 USDT de fonds simulés',
  xzjs: 'Choisissez le rôle que vous souhaitez devenir',
  cwty: 'Devenir membre',
  cwtz: 'Devenir capitaine',
  cjtd: 'Créer une équipe',
  jtgz: 'Règles de création d équipe :',
  jtgz1: '1. Si l équipe n atteint pas 5 personnes dans les 24 heures, elle sera dissoute automatiquement et inscrite au concours individuel simulé',
  jtgz2: '2. Pendant l attente de la formation de l équipe, vous ne pouvez pas vous inscrire au concours individuel simulé',
  jtgz3: '3. Après la formation de l équipe, vous ne pourrez pas rejoindre d autres équipes ni participer au concours individuel simulé',
  tdmc: 'Nom de l équipe :',
  tdjj: 'Présentation de l équipe :',
  ljjt: 'Créer l équipe maintenant',
  tdmcbt: 'Veuillez entrer le nom de l équipe',
  tdjzbt: 'Veuillez entrer la présentation de l équipe',
  cjzdcg: 'Équipe créée avec succès !',
  xzjrtd: 'Choisissez l équipe à rejoindre',
  sstdmc: 'Rechercher le nom de l équipe',
  dqzdsl: 'Nombre d équipes actuelles : {v1}, choisissez l équipe à rejoindre',
  ddtdrs: 'Membres actuels de l équipe : {v1} personnes',
  tdrs: 'Membres de l équipe :',
  tzmc: 'Nom du capitaine :',
  jrtd: 'Rejoindre l équipe',
  jrzdcg: 'Équipe rejointe avec succès !',
  grfxlj: 'Lien de partage personnel :',
  grtjm: 'Code de recommandation personnel :',
  tdfxlj: 'Lien de partage de l équipe :',
  tdtjm: 'Code de recommandation de l équipe :',
  tdtzm: 'Nom du capitaine de l équipe :',
  bctp: 'Enregistrer l image',
  total: 'Total : {v1}',
  dd: 'Aller à la page',
  qd: 'Confirmer',
  cyyj: 'Participation récompensée',
  jcdnn: 'Le prize pool USDT vous attend !',
  jzcj: 'Faire un don des bénéfices, participer au tirage',
  dqjc: 'Prize pool actuel :',
  qjz: 'Faire un don',
  jzsm: 'Instructions de don',
  kjz: 'Vous pouvez actuellement faire un don de {v1} USDT au fonds caritatif. Confirmer le don ?',
  qxjz: 'Annuler le don',
  qrjz: 'Confirmer le don',
  jzcg: 'Félicitations, don réussi !',
  mnpjyds: 'Concours de trading simulé',
  bm: 'Inscription :',
  bs: 'Compétition :',
  hyspjyds: 'Concours de trading à terme ',
  xhspjyds: 'Concours de trading spot',
  bmz: 'Inscription en cours',
  jqqd: 'À venir',
  bsz: 'En compétition',
  yjs: 'Terminé',
  myptts: 'Concours d équipe simulé ',
  mypzmxs: 'Étoile de la semaine',
  mypgrs: 'Concours individuel simulé',
  hyjyds: 'Concours de trading à terme ',
  xhjyds: 'Concours de trading spot',
  my: 'Mon',
  pm: 'Classement',
  dync: 'Pseudo du membre',
  dm: 'Nom de l équipe',
  zdrs: 'Membres de l équipe',
  nc: 'Pseudo',
  ljzjy: 'Volume total de trading',
  ljzjye: 'Montant total des échanges',
  ljzyll: 'Taux de rentabilité total cumulé',
  zyll: 'Taux de rentabilité total',
  zdjl: 'Récompenses de l équipe',
  mypbsjl: 'Participation récompensée',
  myphycs: 'Participer au concours à terme simulé',
  myhyj: 'L inscription donne droit à 100 000 USDT de fonds à terme simulés',
  ljbm: 'Participer maintenant',
  tzjl: 'Création d équipe récompensée',
  ztcg: '5 personnes pour former une équipe,上限200 personnes',
  bwzbhl: 'Le capitaine qui forme une équipe reçoit 100 000 USDT+',
  yqjl: 'Récompenses d invitation',
  yqhycybs: 'Invitation par le capitaine, jusqu à 100 000 USDT',
  hzhyj: 'Invitation par les membres, jusqu à 50 000 USDT',
  mnttbssm: 'Règles du concours d équipe simulé',
  // 团队赛规则
  csxq: 'Détails de participation :',
  csxq1: '1. De la date de début de l inscription jusqu à la fin de la compétition, tout utilisateur (après vérification d identité) peut créer une équipe. Pour le concours d équipe à terme, l équipe doit avoir ≥5 personnes et ≤200 personnes ; si l équipe n atteint pas 5 personnes dans les 24 heures, elle sera automatiquement dissoute et les membres seront transférés dans la zone individuelle.',
  csxq2: '2. Un utilisateur ne peut rejoindre qu une seule équipe, ne peut pas participer plusieurs fois, et ne peut pas participer simultanément au concours d équipe et au concours individuel. Une fois l équipe rejointe, on ne peut pas la quitter volontairement.',
  ssgz: 'Règles de la compétition :',
  ssgz1: '1. Avantages du capitaine : 1) Le captaine reçoit 1000 USDT de fonds simulés pour chaque membre invité,上限100 000 USDT ;',
  ssgz1_2: '          2) Le capitaine qui invite avec succès plus de 20 amis qui tradent reçoit un kit de goodies Biking.',
  ssgz2: '2. Avantages des membres : Chaque membre qui invite un ami reçoit 500 USDT de fonds à terme simulés,上限50 000 USDT',
  ssgz3: '3. À la fin du concours d équipe, la plateforme classera les équipes selon le volume total de trading réel',
  ssgz4: '4. Le volume total de trading de la zone d équipe sera mis à jour à 0h chaque jour',
  ssgz5: '5. Pour garantir l équité, veuillez ne pas passer d ordres fictifs. En cas de detection de comportements frauduleux, l équipe客服 Biking interviendra.',
  ssgz6: '6. Pour plus de détails, veuillez contacter l équipe客服 Biking.',
  jlfp: 'Distribution des récompenses :',
  jlfp1: '1. Distribution du prize pool USDT : (Lors de la distribution, les fonds à terme spécialisés et les liquidités sont toujours distribués dans un rapport 9:1)',
  jlfp1_1: '1) Ratio de distribution au sein de l équipe :',
  jlfp1_2: 'Le capitaine reçoit = Volume de trading à terme personnel cumulé du capitaine / Volume total de trading du concours d équipe Biking * 5 000 000 USDT',
  jlfp1_3: '+ Somme des performances des autres membres / Volume total de trading * 20% * 5 000 000 USDT.',
  jlfp1_4: 'Les membres reçoivent = Volume de trading à terme cumulé de l utilisateur / Volume total de trading * 80% * 5 000 000 USDT.',
  jlfp1_5: '2) Les équipes performantes bénéficient d un bonus collectif ! Le ratio de bonus dépend du nombre de membres et du volume total de trading.',
  myptdjyze: 'Volume total de trading de la zone d équipe',
  myptdphb: 'Classement des équipes du concours simulé',
  tdsl: 'Nombre d équipes actuelles : {v1}, choisissez l équipe à rejoindre',
  tznc: 'Pseudo du capitaine :',
  tdjs: 'Présentation de l équipe :',
  // 周明星规则
  mypzmxgzsm: 'Règles de l étoile de la semaine',
  zmxphb: 'Classement des équipes étoiles de la semaine (top 3)',
  zmxtdphb: 'Classement des équipes de l étoile de la semaine',
  bdxq: 'Détails du classement :',
  bdxq1: '1. La participation au classement de l étoile de la semaine commence dès la création de l équipe et le début du trading',
  zmxgz: '1. Le système classe les équipes par volume total de trading chaque semaine civile et affiche le "Classement des étoiles de la semaine". Les 3 premières équipes se partagent 2 000 000 USDT de fonds à terme simulés.',
  zmxgz1: '2. Le classement est mis à jour chaque mercredi à 14h00',
  bddym: '1er prix : 1 000 000 USDT de fonds à terme simulés ;',
  dbdem: '2ème prix : 600 000 USDT de fonds à terme simulés ;',
  bddsm: '3ème prix : 400 000 USDT de fonds à terme simulés ;',
  tdnbfpgz: 'Règles de distribution au sein de l équipe :',
  tzx: 'Le capitaine reçoit : 20% ;',
  nbyjpm: 'Top 10 des membres (sauf le capitaine) : se partagent 40%',
  syty: 'Autres membres : 40%',
  // 个人赛规则
  mypgrsgzsm: 'Règles du concours individuel simulé',
  mypgrphb: 'Classement individuel du concours simulé',
  bsxz: 'À savoir avant de participer :',
  bsxz1: '1. Chaque nouvel utilisateur inscrit reçoit 100 000 USDT de fonds à terme simulés',
  bsxz2: '2. Les anciens utilisateurs inscrits reçoivent 50 000 USDT de fonds à terme simulés',
  bsxz3: '2. Pendant la compétition, les utilisateurs peuvent continuer à recevoir des fonds en invitant des amis :',
  bsxz4: '1) Chaque ami invité donne droit à 2000 USDT de fonds simulés ;',
  bsxz6: '2) Les récompenses d invitation sont limitées à 50 000 USDT de fonds à terme simulés',
  bsxz7: '3. Cette zone est uniquement ouverte aux utilisateurs vérifiés de Biking.',
  bsxz8: '4. À la fin de la compétition, le classement sera basé sur le volume total de trading.',
  grgzsm1: '1. Prize pool total : 2 000 000 USDT + 30 lots de goodies',
  grgzsm2: '2. Détails de la distribution :',
  grgzsm3: '1er : 800 000 USDT + 5 lots de goodies',
  grgzsm4: '2ème : 500 000 USDT + 5 lots de goodies',
  grgzsm5: '3ème : 200 000 USDT + 3 lots de goodies',
  grgzsm6: '4ème-20ème : se partagent 500 000 USDT + 17 lots de goodies',
  hyjybs: 'Concours de trading à terme',
  hyjybsgzsm: 'Règles du concours de trading à terme',
  hyspgrphb: 'Classement individuel du concours à terme',
  // 合约大赛规则
  csxz: 'À savoir avant de participer :',
  hybsgz1: '1. L inscription au concours donne droit à 100 USDT de fonds à terme spécialisés (voir les règles de la plateforme). Les profits réalisés avec ces fonds ne sont pas inclus dans le taux de rentabilité.',
  hybsgz2: '2. Les utilisateurs peuvent inviter des amis. Chaque ami invité donne droit à 20 USDT de fonds spécialisés,上限100 USDT.',
  hybsgz3: '3. Cette zone est uniquement ouverte aux utilisateurs vérifiés de Biking.',
  hybsgz4: '4. À la fin de la compétition, le classement sera basé sur le taux de rentabilité total.',
  jcfp: 'Distribution du prize pool :',
  jcfp1: 'Prize pool total : 2 000 000 USDT + 30 lots de goodies',
  fpgz: 'Règles de distribution :',
  fpgzs: '(Lors de la distribution, les fonds spécialisés et les liquidités sont toujours distribués dans un rapport 9:1)',
  fpgz1: '1er : 800 000 USDT + 5 lots de goodies',
  fpgz2: '2ème : 500 000 USDT + 5 lots de goodies',
  fpgz3: '3ème : 200 000 USD + 3 lots de goodies',
  fpgz4: '4ème-20ème : se partagent 500 000 USDT + 17 lots de goodies',
  hjyq: 'Exigences pour gagner',
  hjyq1: '1. Le profit du concours = Valeur finale du compte (incluant les profits/pertes non réalisés) - Valeur initiale du compte (incluant les profits/pertes non réalisées) - Fonds de participation.',
  hjyq2: '2. En cas de profit égal, celui avec le volume de trading le plus élevé l emporte.',
  hjyq3: '3. Les gagnants doivent avoir un profit positif.',
  // 捐赠
  gyc1: 'Ce prize pool est uniquement ouvert aux utilisateurs des zones de trading à terme et spot. Les utilisateurs peuvent terminer tôt la compétition et faire un don de leur volume de trading/profit au fonds caritatif.',
  gyc2: 'Le système versera 0,5 USDT par point de profit au fonds caritatif. Le solde sera affiché sur la page de compétition.',
  gyc3: 'Par exemple, si un utilisateur a un profit de 38%, le système versera 38*0,5=19 USDT au fonds caritatif.',
  gyc4: '上限 du fonds caritatif : 50 000 USDT de fonds à terme spécialisés',
  gyc5: 'Pour le don de volume de trading, le système verse 0,5 USDT par 100 USDT. Exemple : 1000 USDT de volume = 5 USDT de don.',
  gyc7: 'Note : Chaque utilisateur ne peut faire qu un seul don. Une fois le don effectué, l utilisateur perd tout droit de classement, de récompense et de participation.',
  gyc8: 'Après la compétition, le fonds caritatif organisera trois tours de tirage au sort, 10 personnes par tour, selon les ratios 40%, 30%, 30%.',
  gyc9: 'Heure du tirage : Dans les 7 jours ouvrables après la fin de la compétition.',
  xhjybs: 'Concours de trading spot',
  xhjybsgzsm: 'Règles du concours de trading spot',
  xhjydsphb: 'Classement du concours de trading spot',
  grbmcg: 'Inscription individuelle réussie !',
  // 现货实大赛规则
  xhgz1: '1. Le concours de trading spot inclut toutes les paires de trading spot de la plateforme',
  xhgz2: '2. Les participants doivent avoir un solde spot supérieur à 50 USDT',
  xhgz3: '3. À la fin de la compétition, la plateforme classera les utilisateurs selon le volume total de trading spot',
  jjfp: 'Distribution des récompenses',
  zjc: 'Prize pool total : 1 000 000 USDT + 20 lots de goodies',
  xhdym: '1er : 400 000 USDT + 10 lots de goodies',
  xhdem: '2ème : 200 000 USDT + 5 lots de goodies',
  xhdsm: '3ème : 100 000 USDT + 5 lots de goodies',
  xhdsm1: '4ème-20ème : se partagent 300 000 USDT',
  mypdnpm: 'Classement intra-équipe du concours simulé',
  yqjl1: 'Récompenses d invitation',
  wdjye: 'Mon volume de trading :',
  wdzsyl: 'Mon taux de rentabilité total :',
  grzjyl: 'Volume total de trading individuel du concours simulé :',
  grzsyl: 'Rentabilité totale individuelle du concours simulé :',
  sqzjye: 'Volume total de trading de la zone :',
  zjye: 'Volume total de trading de la zone :',
  bsyqrs: 'Nombre d invitations :',
  ren: 'personnes',
  hdmnj: 'Fonds simulés reçus :',
  hdzj: 'Fonds reçus :',
  hyjyxq: 'Détails du concours à terme',
  xhjyxq: 'Détails du concours spot',
  hy: 'À terme',
  xh: 'Spot',
  jlsm: 'Explication des récompenses',
  jlsm1: '1. Pendant la compétition, tout utilisateur (après vérification) peut créer une équipe. Pour le concours d équipe à terme : ≥5 personnes, ≤200 personnes. Si moins de 5 en 24h, dissolution automatique.',
  jlsm2: '2. Chaque personne ne peut rejoindre qu une seule équipe, sans possibilité de sortie volontaire',
  tdjye: 'Volume de trading de l équipe :',
  wdjs: 'Mon rôle :',
  dz: 'Capitaine',
  dy: 'Membre',
  tdzyll: 'Rentabilité totale de l équipe :',
  wdzyll: 'Ma rentabilité totale :',
  tdyjhdjl: 'Récompenses预计 de l équipe :',
  tdjs1: 'Présentation de l équipe',
  grxq: 'Détails personnels',
  tdxq: 'Détails de l équipe',
  tdjylpm: 'Classement du volume de trading de l équipe :',
  tdzsyl: 'Rentabilité totale de l équipe',
  tdnphb: 'Classement intra-équipe',
  tcsybs: 'Tips : Le don vous fait quitter toutes les compétitions',
  zwcjhybs: 'Pas encore participant au concours à terme simulé',
  zwsj: 'Aucune donnée',
  tdmcbzq: 'Format du nom d équipe invalide',
  tdjjbzq: 'Format de présentation d équipe invalide',
  hdjxz_contract: 'Le concours de trading à terme permanent bat son plein, participez pour partager le prize pool de 2 000 000 USDT et gagner de riches goodies Biking',
  hdjxz_spot: 'Le concours de trading spot bat son plein, participez pour partager le prize pool de 1 000 000 USDT et gagner de riches goodies Biking',
  hdjs: 'Attendez la prochaine compétition',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/fr.js